import * as R from 'ramda'

import Login from '../pages/Login'
import withLogin from '../utils/withLogin'
import BlogDetail from './BlogDetail'
import BlogList from './BlogList'
import CategoryDetail from './CategoryDetail'
import CategoryList from './CategoryList'
import CompanyDetail from './CompanyDetail'
import CompanyList from './CompanyList'
import Error404 from './Error404'
import Setting from './Setting'

export type NavigationType = {
  key: string
  path: string
  name: string
  component: any
  exact?: boolean
}

export const routes = [
  {
    key: 'login',
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    key: 'companyList',
    path: '/company',
    name: 'pageName.companyList',
    component: CompanyList,
    iconType: 'profile'
  },
  {
    key: 'companyEdit',
    path: '/company/:companyId/edit',
    name: 'Company Detail',
    component: CompanyDetail
  },
  {
    key: 'companyView',
    path: '/company/:companyId/view',
    name: 'Company Detail',
    component: CompanyDetail
  },
  {
    key: 'companyCreate',
    path: '/company/create',
    name: 'Company Detail',
    component: CompanyDetail
  },
  {
    key: 'categoryList',
    path: '/category',
    name: 'pageName.categoryList',
    component: CategoryList
  },
  {
    key: 'categoryEdit',
    path: '/category/:categoryId/edit',
    name: 'Category Detail',
    component: CategoryDetail
  },
  {
    key: 'categoryCreate',
    path: '/category/create',
    name: 'Category Detail',
    component: CategoryDetail
  },
  {
    key: 'blogList',
    path: '/blog',
    name: 'pageName.blogList',
    component: BlogList
  },
  {
    key: 'blogView',
    path: '/blog/:blogId/view',
    name: 'Blog Detail',
    component: BlogDetail
  },
  {
    key: 'blogEdit',
    path: '/blog/:blogId/edit',
    name: 'Blog Detail',
    component: BlogDetail
  },
  {
    key: 'blogCreate',
    path: '/blog/create',
    name: 'Blog Detail',
    component: BlogDetail
  },
  {
    key: 'setting',
    path: '/setting',
    name: 'Setting',
    component: Setting
  },
  {
    key: 'main',
    path: '/',
    name: 'pageName.companyList',
    component: CompanyList
  },
  {
    key: 'error',
    path: '*',
    name: 'pageName.errorPage',
    component: Error404
  }
]

export const Navigation = R.map(
  ({ component, ...route }: NavigationType) => ({
    ...route,
    component: withLogin(component)
  }),
  routes
)

// export const menuConfig = [
//   {
//     key: 'genericSetting',
//     title: 'menu.genericSetting',
//     icon: MenuIconGeneric,
//     subMenu: R.filter(R.propEq('showInMenu', MENU.GENERIC))(Navigation),
//   },
//   {
//     key: 'frontendSetting',
//     title: 'menu.frontendSetting',
//     icon: MenuIconFrontend,
//     subMenu: R.filter(R.propEq('showInMenu', MENU.FRONTEND))(Navigation),
//   },
//   {
//     key: 'corporateSetting',
//     title: 'menu.corporateSetting',
//     icon: MenuIconCorporate,
//     subMenu: R.filter(R.propEq('showInMenu', MENU.CORPORATE))(Navigation),
//   },
//   {
//     key: 'fundraisingEventSetting',
//     title: 'menu.fundraisingEventSetting',
//     icon: MenuIconPersonal,
//     subMenu: R.filter(R.propEq('showInMenu', MENU.FUNDRAISING_EVENT))(
//       Navigation
//     ),
//   },
// ]
